<template>
  <div class="vip">
    <div class="content">
      <div class="banner">
        <div class="p15">
          <div class="banner-title"></div>
          <div class="banner-desc">
            累计 <span>1000万+</span> 用户使用答题，创建
            <span>20万+</span> 个活动<br />
            支持企业培训、在线教育、有奖竞赛等场景
          </div>

          <div class="vip-intro">
            <div class="flexCenter">
              <img
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/ac050edbf881e33f4fc8e1eb40ea8856.svg"
                alt=""
              />高级版权益介绍
            </div>
            <div class="vip-intro-desc">
              答题活动发起方可通过升级到高级版获得额外功能和权益，其账号在付费期间创建的所有答题均可使用。费用支持开发票，如有疑问请<a
                @click="handleContact()"
                >点击联系客服</a
              >
            </div>
          </div>
        </div>
        <div class="main">
          <div class="p15">
            <div class="goods-content ">
              <div
                v-for="(item, index) in goodsInfo"
                :key="index"
                class="goods-items"
              >
                <div v-if="index === 0" class="version">
                  当前版本：{{
                    enterprise_vip
                      ? "高级版（" + enterprise_vip_end + "到期）"
                      : "基础版"
                  }}
                </div>
                <div class="header flex goods-row">
                  <div class="header-item">
                    <img :src="infosTitle[index].img" alt="" />
                    {{ infosTitle[index].title }}
                  </div>
                  <div class="header-item">基础版</div>
                  <div class="header-item">高级版</div>
                </div>
                <div class="goods-content-row">
                  <div
                    v-for="(cItm, cIndex) in item"
                    :key="cIndex"
                    class="flex goods-row"
                  >
                    <div class="goods-item">{{ cItm[0] }}</div>
                    <div class="goods-item">
                      <template v-if="cItm[1]">
                        <div v-for="(gItem, gIndex) in cItm[1]" :key="gIndex">
                          {{ gItem }}
                        </div>
                      </template>
                      <div v-else>
                        <img
                          class="right-icon"
                          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-03/6d4a0c3e87a7a0f571da894d195b57cc.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="goods-item">
                      <template v-if="cItm[2]">
                        <div v-for="(gItem, gIndex) in cItm[2]" :key="gIndex">
                          {{ gItem }}
                        </div>
                      </template>
                      <template v-else>
                        <img
                          class="right-icon"
                          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-03/14c64a788c5c0849cb185120244eed59.png"
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="buy-box">
      <div class="btn-buy-contact" @click="handleContact">企业购买/对公开票，联系客服  ></div>
      <div class="productList" v-if="productList.length">
        <div class="swiper-item">
          <div
            v-for="(item, index) in productList"
            :key="index"
            :class="[
                  'price-item',
                  index === productIndex ? 'curr-select' : null
                ]"
            @click="changeProduct(index)"
          >
            <div class="price-desc">{{ item.name }}</div>
            <div class="price-now">
              <span>￥</span><span class="price-num">{{ item.price }}</span>
            </div>
            <div v-if="item.discount" class="price-old">
              {{ item.discount }}
            </div>
            <div v-if="item.info" class="cen-discount">{{ item.info }}</div>
          </div>
          <div class="price-item contact-item" @click="handleContact">
            <span>企业购买<br>对公开票</span>
            <span>联系客服</span>
            <div class="cen-discount"></div>
          </div>
        </div>
      </div>
      <div class="agreement" @click="handleCheck">
        <img
          class="checkIcon"
          :src="checkActive ? checkIcon[1] : checkIcon[0]"
        />同意<span class="file" @click="toAgreement">《用户协议》</span>并接受虚拟服务购买后不支持退款
      </div>
      <div class="buy-btn" @click="pay" v-if="productList.length">
        {{ enterprise_vip ? "立即续费" : "立即购买" }}&nbsp;{{productList[productIndex].name}}&nbsp;¥{{
          productList[productIndex].price
        }}
      </div>
    </div>
    <div class="mask-box" v-if="showModal">
      <div class="mask-content">
        <div class="confirm-bd">
          {{ buyInfo }} <br />
          到期时间: {{ b_time }}
        </div>
        <div class="confirm-footer">
          <div class="confirm-cancel" @click="closeConfirm">我知道了</div>
          <div class="confirm-ok">
            <!-- <template v-if="isWeixin">
              <wx-open-launch-weapp
                username="gh_f208968c610c"
                @launch="handleLaunchFn"
                @error="handleErrorFn"
                appid="wx2aed548e27e28de9"
                :path="path"
              >
                <script type="text/wxtag-template">
                  <div style="color: #12b7f5; height: 50px; line-height: 50px">前往小程序</div>
                </script>
              </wx-open-launch-weapp>
            </template> -->
            <template>
              <span class="goWx" @click="getWxSchema()">前往小程序</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
    <template v-if="showLogin">
      <ScanLogin
        @hideVisible="handleScan()"
        :type="qrcodeType"
        :targetIndex="productIndex"
        :productList="productList"
        :payType="payType"
        :src="loginQrcode"
      />
    </template>
    <van-popup v-model="bindVisible" position="bottom" duration="0.1">
      <get-phone @bindSuccess="bindSuccess" @hideVisible="handleBind()" />
    </van-popup>

    <template v-if="showScan">
      <scan-code
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/3cd24fad2262b8ef5e684b8e2c9759c3.png"
        @hideVisible="handleScanCode"
      ></scan-code>
    </template>

    <template v-if="!isMobile">
      <right-code
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-03/b0b4a827c1aacf0d9071f794c10a408b.jpg"
      />
    </template>
    <van-popup :close-on-click-overlay="false" v-model="failVisible" :style="{ borderRadius: '10px'}" duration="0.1">
      <pay-fail @continuePay="continuePay" @closeFail="closeFail" />
    </van-popup>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import {
  jumpWxAuth,
  getToken,
  formatDateTime,
  isMobile,
  isWeixin,
  verifyAuth,
  getWxUrl,
  showServiceAble,
  getQueryString,
  vipClick,
  handleCode
} from "@/utils/common";
import api from "@/utils/api";
import { checkIcon } from "@/utils/config";
import { Toast, Dialog } from "vant";
import ContactImg from "@/components/contactImg";
import ScanLogin from "@/components/scanLogin";
import RightCode from "../../components/rightCode.vue";
import ScanCode from "@/components/scanCode.vue";
import GetPhone from "../../components/getphone.vue";
import { throttle } from "lodash";
import { handleZI } from "../../utils/common";
import PayFail from "@/components/common/payfail.vue";

let checkTime = 0;
let intervalAsk;

export default {
  data() {
    return {
      payType: 0,
      showScan: false,
      showLogin: false,
      loginQrcode: "",
      qrcodeType: 0,
      showRightCode: false,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      showContact: false,
      enterprise_vip: 0,
      enterprise_vip_start: "",
      enterprise_vip_end: "",
      buyInfo: "",
      showModal: false,
      path: "/pages/createdefault/createdefault",
      name: "立吉答题用户",
      avatar: "",
      productIndex: 1,
      b_time: "",
      infosTitle: [
        {
          img:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/954ca578ba88e568b494c49c0d90082d.svg",
          title: "出题规则"
        },
        {
          img:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/bd5637482ca652975625d02f63a6c1a0.svg",
          title: "防作弊"
        },
        {
          img:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/853b43e72d41891985b723f56149ed47.svg",
          title: "数据下载"
        },
        {
          img:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-03/4cd5b8c5b91d652ad9d7e05dc5ecff57.png",
          title: "其他"
        }
      ],
      productList: [],
      hasUserInfo: false,
      goodsInfo: [
        [
          ["同时在线人数", ["50人"], ["无限制"]],
          ["总答题次数", ["1000次/场"], ["无限制"]],
          ["单场出题数", ["100题/场"], ["无限制"]],
          [
            "题库总题量",
            ["上限2000题"],
            ["200个题库", "（单个1000题）"]
          ],
          ["单次答题总时长", ["60分钟/场"], ["无限制"]],
          ["数据保存时长", ["截止后6个月"], ["高级版期间", "一直保存"]],
          ["答题内容极速审核", "", ""],
          ["隐藏得分", "", ""]
        ],
        [
          ["单题限时", "", ""],
          ["防切屏/截屏", "", ""],
          ["禁止录屏", "", ""],
          ["禁止粘贴", "", ""],
          ["禁止长按保存、识别答题中图片", "", ""],
          ["选项乱序", "", ""]
        ],
        [
          ["排行榜展示", ["固定50人"], ["最高1000人", "或隐藏"]],
          ["下载全部排名", "", ""],
          ["作答详情 (Word)", ["单次：1条"], ["批量下载"]],
          ["作答详情 (Excel)", "", ""],
          ["导出题目 (Word)", "", ""],
          ["题目错误率", "", ""]
        ],
        [
          ["答题口令", "", ""],
          ["发起人昵称修改", "", ""],
          ["分享后增加答题次数", "", ""],
          ["解析支持公众号文章", "", ""],
          ["H5链接分享", "", ""],
          ["分享图自定义Logo", "", ""],
          ["答题管理员人数", ["2"], ["50"]],
          ["简介/题目支持视频", "", ""],
          ["高清图片", "", ""],
          ["提交后展示提示语", "", ""],
          ["内置抽奖活动", "", ""],
          ["去除小程序内部广告（不含开屏广告）", "", ""]
        ]
      ],
      checkIcon: checkIcon,
      checkActive: true,
      bindVisible: false,
      phone: "",
      failVisible: false
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    ContactImg,
    ScanLogin,
    RightCode,
    ScanCode,
    GetPhone,
    PayFail
  },
  async mounted() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
    if (getQueryString("ut")) {
      localStorage.setItem("token", getQueryString("ut"));
      this.getProduct();
      this.handleUserInfo();
      return;
    }
    this.getProduct();
    let loginStatus = await verifyAuth();
    if (loginStatus) {
      this.handleUserInfo();
    } else {
      if (this.isWeixin) {
        if (getToken()) {
          jumpWxAuth();
        } else {
          if (!getToken() && getQueryString("code")) {
            let res = await handleCode(getQueryString("code"));
            if (res) {
              this.handleUserInfo();
              // let arr = document.location.toString().split("&code=")[0];
              // window.location.replace(arr);
            }
            return;
          }
        }
      } else {
        if (!this.isMobile) {
          // pc
          this.getLoginCode();
        }
      }
    }
    //
  },
  methods: {
    reset() {
      localStorage.setItem("token", "212");
      Toast("重置成功");
    },
    cleartoken() {
      localStorage.clear();
      sessionStorage.clear();
      Toast("token已清除");
    },
    bindSuccess(phone) {
      this.phone = phone;
      this.bindVisible = false;
      this.pay();
    },
    async getWxSchema(type) {
      if (this.isMobile) {
        let path = type ? "pages/vip/vip" : "pages/createdefault/createdefault";
        let url = await getWxUrl(path, "", 1);
        if (url) window.location.href = url;
      } else {
        this.showModal = false;
        this.handleScanCode();
      }
    },
    handleBind() {
      this.bindVisible = !this.bindVisible;
    },
    handleScanCode() {
      this.showScan = !this.showScan;
    },
    getProduct() {
      questionOnly
        .get("/xcx/ques/v2/produce/detail", {
          type: 4,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta == 0) {
            if (res.data.product_list) {
              let product_list = res.data.product_list || [];
              if (!localStorage.getItem("continue_pay")) {
                let checkedIndex = 0;
                product_list.forEach((item, index) => {
                  if (item.checked) {
                    checkedIndex = index;
                  }
                });
                this.productIndex = checkedIndex;
              }
              this.productList = product_list;
            }
          }
        });
    },

    getLoginCode() {
      var timestamp = new Date().getTime();
      var myToken =
        timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
      // 获取二维码  开始轮询请求，如果返回ok，清除轮询
      questionOnly
        .get("/xcx/ques_web/v1/qrcode", { token: myToken })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 0;
            if (!this.showLogin) this.showLogin = true;
            checkTime = 0;
            this.checkLoginSuccess(myToken);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    getPayCode() {
      questionOnly
        .post("/xcx/ques/v1/order", {
          access_token: getToken(),
          type: "enterprise_vip",
          duration: this.productList[this.productIndex].days,
          pay_source: 1 // 付费来源 1:h5, 2:pc, 3:腾讯会议, 默认为1
        })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 1;
            this.showLogin = true;
            checkTime = 0;
            this.checkPaySuccess(res.data.order_id);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    checkPaySuccess(order_id) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getPayCode();
        return;
      }
      questionOnly
        .get("/xcx/ques/v1/order_status", {
          access_token: getToken(),
          order_id,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkPaySuccess(order_id);
            }, 3000);
          } else {
            // 支付成功
            this.showLogin = false;
            let b_end = "";
            let duration = this.productList[this.productIndex].days;
            if (this.enterprise_vip) {
              b_end =
                new Date(this.enterprise_vip_end).getTime() +
                duration * 86400000;
            } else {
              b_end = new Date().getTime() + duration * 86400000;
            }
            b_end = formatDateTime(b_end, 3);
            let buyInfo = this.enterprise_vip ? "续费成功！" : "购买成功！";
            this.showModal = true;
            this.b_time = b_end;
            this.buyInfo = buyInfo;
            this.handleUserInfo("refresh");
          }
        });
    },
    checkLoginSuccess(myToken) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(myToken);
            }, 3000);
          } else {
            // 登录成功
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid);
            setTimeout(() => {
              this.showLogin = false;
              this.handleUserInfo();
            }, 100);
          }
        });
    },
    handleScan() {
      if (intervalAsk) {
        clearInterval(intervalAsk);
        intervalAsk = null;
      }
      this.showLogin = !this.showLogin;
      if(this.qrcodeType == 1) {
        this.failVisible = true;
      }
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    handleCheck() {
      this.checkActive = !this.checkActive;
    },
    toAgreement() {
      this.$router.push({ name: "agreement" });
    },
    closeConfirm() {
      this.showModal = false;
    },
    handleLaunchFn() {},
    handleErrorFn() {},
    // 价格切换
    changeProduct(e) {
      this.productIndex = e;
    },
    //获取用户信息
    handleUserInfo(refresh) {
      let param = { access_token: getToken() };
      if (refresh) {
        param.refresh = 1;
      }
      questionOnly.get(api.question.getServiceDetail, param).then(res => {
        if (res.sta == 0) {
          let {
            name,
            avatar,
            enterprise_vip,
            enterprise_vip_start,
            enterprise_vip_end,
            phone
          } = res.data;
          this.phone = phone;
          this.hasUserInfo = true;
          this.name = name;
          this.avatar = avatar;
          this.enterprise_vip_start = formatDateTime(
            enterprise_vip_start * 1000,
            3
          );
          this.enterprise_vip_end = formatDateTime(
            enterprise_vip_end * 1000,
            3
          );
          this.enterprise_vip = enterprise_vip;
          // 判断来源: msg_type: 1 vip临期提醒 2：vip过期提醒
          let msg_type = localStorage.getItem("msg_type") || 0;
          let continue_pay = localStorage.getItem("continue_pay") || 0;
          let continue_pay_index =
            localStorage.getItem("continue_pay_index") || 1;
          if (localStorage.getItem("msg_type"))
            localStorage.removeItem("msg_type");
          if (getQueryString("msg_type") && getQueryString("msg_type") > 0) {
            msg_type = getQueryString("msg_type");
          }
          if (msg_type > 0) {
            let arr = [
              { type: "vip_to_exp_msg", name: "vip临期提醒", value: 1 },
              { type: "vip_expire_msg", name: "vip过期提醒", value: 2 },
              { type: "public_number_lead", name: "公众号引导", value: 3 }
            ];
            let item = arr.find(item => item.value == msg_type);
            if (item) {
              vipClick(item.type, item.name);
            }
          } else {
            vipClick("h5_pay_link", "h5支付链接");
          }
          if (continue_pay) {
            localStorage.removeItem("continue_pay");
            localStorage.removeItem("continue_pay_index");
            this.productIndex = continue_pay_index * 1;
            this.pay();
          }
        } else if (res.sta == -500) {
          jumpWxAuth();
        }
      });
    },
    // 支付
    pay: throttle(
      async function() {
        if (!this.checkActive) return Toast("请先勾选协议");
        if (!this.isWeixin) {
          // 不在微信里面打开
          if (this.isMobile) {
            // 其它浏览器手机端直接跳转到小程序
            return this.getWxSchema(1);
          } else {
            // 电脑端
            if (!this.hasUserInfo) {
              // 没登录先登录
              return this.getLoginCode();
            } else {
              if (!this.phone) return (this.bindVisible = true);
              return this.getPayCode();
            }
          }
        } else if (this.isWeixin && !this.hasUserInfo) {
          // 微信里面没登录
          localStorage.setItem("continue_pay", 1);
          localStorage.setItem("continue_pay_index", this.productIndex);
          return jumpWxAuth();
        }

        if (!this.isMobile) {
          // 微信电脑端打开扫码支付
          if (!this.phone) return (this.bindVisible = true); //如果没有绑定则需先绑定手机号
          return this.getPayCode();
        }
        // 正常调取微信sdk支付
        if (!this.phone) return (this.bindVisible = true);
        let self = this;
        let duration = this.productList[this.productIndex].days;
        let enterprise_vip = this.enterprise_vip;
        let param = {
          access_token: getToken(),
          type: "enterprise_vip",
          source: "h5",
          duration
        };
        questionOnly.post(api.question.bookVipBuy, param).then(res => {
          if (res.sta == 0) {
            let b_end = "";
            if (enterprise_vip) {
              b_end =
                new Date(this.enterprise_vip_end).getTime() +
                duration * 86400000;
            } else {
              b_end = new Date().getTime() + duration * 86400000;
            }
            b_end = formatDateTime(b_end, 3);
            let buyInfo = enterprise_vip ? "续费成功！" : "购买成功！";
            window.wx.chooseWXPay({
              timestamp: res.data.timeStamp,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              signType: res.data.signType,
              paySign: res.data.paySign,
              appId: res.data.appId,
              success: function(res) {
                self.showModal = true;
                self.b_time = b_end;
                self.buyInfo = buyInfo;
                self.handleUserInfo("refresh");
              },
              fail: error => {
                Toast(error.errMsg);
              },
              cancel: err => {
                this.failVisible = true;
              }
            });
          } else {
            Toast(res.msg);
          }
        });
      },
      2000,
      { trailing: false }
    ),
    continuePay() {
      this.failVisible = false;
      this.pay()
    },
    closeFail(type) {
      if(type == 1) {
        this.failVisible = false;
      }else {
         _ZHINI({ action: 'showPanel' })
      }
    }
  },
  destroyed() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
  }
};
</script>

<style scoped lang="scss">
.vip {
  background: #ffffff;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
  height: 2575px;
  // height: calc(100vh);
  // overflow-y: scroll;
  // overflow-x: hidden;
  position: relative;
}

.content {
  // padding: 0 0 15px;
  background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-11/2e714355cc6072332ba70410b2e7ed0c.png");
  background-size: cover;
  background-size: 100% 100%;
  height: 600px;
}
// https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-11/d89b87e1360cad89d8d30f8dc173d34c.png
// https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-11/2e714355cc6072332ba70410b2e7ed0c.png
.banner {
  box-sizing: border-box;
  background-size: 100% 100%;
  // margin: 0 15px 15px;
  padding: 25px 0;
  color: #ffffff;
  height: 600px;
  // position: absolute;
  left: 0;
  right: 0;
  top: 0;
}
.main {
  // position: absolute;
  z-index: 3;
  top: 260px;
  left: 0;
  right: 0;
  padding-bottom: 280px;
  padding-bottom: calc(280px + env(safe-area-inset-bottom));
  color: #262626;
}
.banner-title {
  // font-size: 24px;
  // font-weight: 900;
  // line-height: 25px;
  // margin-bottom: 10px;
  margin-left: 8px;
  // text-shadow: 1px 1px 0 rgba(0,0,0,.6);
  width: 322px;
  height: 39px;
  object-fit: cover;
  background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-11/8fec7d8147ae5f3739dc62271707fe23.png");
  background-size: cover;
}
.active-text {
  color: #ffb76f;
}
.banner-desc {
  font-size: 13px;
  line-height: 24px;
  padding: 0 15px;
}
.banner-desc span {
  font-weight: bold;
}
.version {
  padding: 15px 10px;
  border-bottom: 1px solid #eeeeee;
  margin: 0 5px;
  font-size: 14px;
  font-weight: bold;
}

.userinfo {
  display: flex;
  align-items: center;
}

.userinfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 5px;
  border: 2px solid #ffffff;
}

.nickname {
  font-weight: 800;
  font-size: 15px;
  line-height: 27px;
}
.handle {
  position: relative;
  font-size: 12px;
  line-height: 19px;
  padding-top: 40px;
}

.handle .handle-btn {
  width: 100px;
  text-align: center;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  background: #ffffff;
  border-radius: 20px;
  font-size: 15px;
  top: 30px;
  color: #000000;
}
.desc {
  font-size: 12px;
  line-height: 18px;
}

.productList {
  overflow-y: auto;
  padding-bottom: 15px;
  margin: 15px 5px 0 15px;
}

.product-item {
  background: #ffffff;
  border-radius: 4px;
  height: 130px;
  min-width: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  border: 2px solid transparent;
  margin-bottom: 15px;
  margin-right: 15px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
  .info {
    position: absolute;
    left: -2px;
    top: -2px;
    background: #fe523c;
    // background: linear-gradient(90deg, #ffc083 0%, #ff7d00 100%);
    border-radius: 4px 0 15px;
    font-size: 12px;
    width: 79px;
    text-align: center;
    color: #ffffff;
    line-height: 18px;
  }
}
.product-item.active {
  border: 2px solid #1890ff;
  color: #1890ff;
}
.product-item img {
  width: 28px;
  height: 28px;
  position: absolute;
  right: -2px;
  bottom: -2px;
}

.name {
  font-size: 14px;
  line-height: 14px;
}

.price {
  font-weight: 900;
  font-size: 20px;
  line-height: 30px;
  margin-top: 2px;
}

.discount {
  font-size: 12px;
  line-height: 18px;
  text-decoration-line: line-through;
  color: #999999;
}
.buy-box {
  position: fixed;
  background: #ffffff;
  left: auto;
  max-width: 500px;
  min-width: 320px;
  bottom: 0;
  width: 100%;
  z-index: 8;
  border-top: 1px solid #eeeeee;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.05);
  padding-bottom: env(safe-area-inset-bottom);
}
.buy-btn {
  height: 45px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1890ff;
  border-radius: 50px;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  margin: 15px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.buy-btn::before {
  content: "";
  position: absolute;
  left: -75px;
  top: -230px;
  width: 345px;
  height: 45px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
  transform: rotate(-45deg);
  animation: searchLights 2s ease-in 0.5s infinite;
}

.btn-buy-contact {
  font-weight: bold;
  font-size: 13px;
  color: #262626;
  padding: 20px 15px 0;
  &::before {
    content: "";
    display: inline-block;
    width: 15px;
    height: 15px;
    background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-03-17/415ce351e210b73fa9acd19a318c608e.svg") no-repeat center;
    background-size: cover;
    margin-bottom: -3px;
    margin-right: 5px;
  }
}

@keyframes searchLights {
  0% {
    left: -250px;
    top: 0;
  }
  to {
    left: 345px;
    top: 0px;
  }
}
.buy-tips {
  font-size: 13px;
  line-height: 16px;
  color: #666666;
  background: #f2f2f7;
  border-radius: 4px;
  padding: 10px;
  margin: 15px 15px 0;
  p {
    margin-bottom: 10px;
    line-height: 18px;
  }
  p:first-child {
    font-size: 15px;
    color: #262626;
  }
  p:last-child {
    margin-bottom: 0;
  }
}
.buy-tips span {
  color: #1890ff;
  cursor: pointer;
}

.vip-intro {
  font-weight: 700;
  padding: 15px 20px;
  color: #000000;
  background: #ffffff;
  border-radius: 4px;
  margin-top: 25px;
  font-size: 15px;
  img {
    width: 15px;
    height: 17px;
    margin-right: 5px;
  }
  .vip-intro-desc {
    font-size: 13px;
    font-weight: normal;
    line-height: 22px;
    margin-top: 10px;
    a {
      color: #1890ff;
      cursor: pointer;
    }
  }
}
.vip-table {
  border: 1px solid #f2f2f7;
  border-radius: 4px;
}
.vip-table img {
  width: 24px;
  height: 24px;
  margin-right: 7px;
}
.table-item {
  display: flex;
  align-items: center;
  padding: 17px 15px;
}

.table-item:nth-child(2),
.table-item:nth-child(4),
.table-item:nth-child(6),
.table-item:nth-child(8),
.table-item:nth-child(11),
.table-item:nth-child(13),
.table-item:nth-child(15) {
  background: #f8fbff;
}
.table-item p {
  flex: 1;
  text-align: center;
  font-size: 12px;
}
.table-item p:first-child {
  text-align: left;
  min-width: 120px;
}
.table-item p:last-child {
  color: #1890ff;
}
.table-item:first-child,
.table-item:nth-child(10),
.table-item:nth-child(14) {
  p:last-child {
    color: #999999;
  }
}
.table-item:first-child,
.table-item:nth-child(10),
.table-item:nth-child(14) {
  background: #f2f2f7;
  color: #999999;
}
.mask-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  z-index: 9;
}
.mask-content {
  background: white;
  width: 330px;
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
}
.confirm-header {
  font-size: 17px;
  padding: 15px 0 7px;
  font-weight: 800;
}
.confirm-bd {
  text-align: left;
  color: #666;
  font-size: 16px;
  line-height: 24px;
  padding: 30px 40px;
}
.confirm-footer {
  // margin: 12px;
  /*width: px580);*/
  height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e0e0e0;
}
.confirm-footer div {
  flex: 1;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
}
.confirm-ok {
  color: #1890ff;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  border-left: 1px solid #eee;
  button {
    font-weight: 700;
  }
}
.agreement {
  font-size: 12px;
  margin: 0 15px 15px;
  display: flex;
  align-items: center;
  color: #999;
}
.agreement .checkIcon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  cursor: pointer;
}
.agreement .file {
  //color: #007aff;
  cursor: pointer;
}
.goodsInfo-img {
  width: 100%;
  display: block;
  margin: 0 auto 10px;
}
.goods-row {
  height: 55px;
  align-items: center;
  font-size: 14px;
  margin: 0 5px;
}
.goods-content-row {
  padding-bottom: 5px;
  .goods-row:nth-child(2n + 1) {
    background: #f8fbff;
  }
  .goods-row > div:last-child {
    color: #1890ff;
  }
}
.goods-row > div:nth-child(1) {
  padding-left: 9px;
}
.goods-row div:nth-child(2),
.goods-row div:nth-child(3) {
  text-align: center;
}

.goods-items {
  border: 1px solid #eeeeee;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 10px;
  .header {
    font-weight: 700;
  }
}
.goods-content {
  font-size: 16px;
  margin-top: 10px;
  .header-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }
  .header-item:first-child {
    justify-content: left;
  }
  .goods-item {
    flex: 1;
  }
}
.goWx {
  display: block;
  height: 100%;
  line-height: 54px;
}
.right-icon {
  width: 12px;
  height: 12px;
}
.swiper-item {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  //width: 400px;
  line-height: 1.15;
  .slider-list {
    margin: 0 15px !important;
  }
  .price-item {
    flex: none;
    box-sizing: border-box;
    width: 80px;
    height: 95px;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
    padding: 0 0 5px 15px;
    position: relative;
    .price-desc {
      font-weight: bold;
      font-size: 12px;
      color: #262626;
    }
    .price-now {
      padding: 5px 0;
      font-size: 12px;
      color: #262626;
      font-weight: bold;
      line-height: 1;
      .price-num {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .price-old {
      font-size: 11px;
      color: #999;
      text-decoration: line-through;
    }
    .cen-discount {
      position: absolute;
      right: -1px;
      bottom: 0px;
      height: 16px;
      padding: 0 5px;
      line-height: 1;
      background-color: #ff3333;
      color: #fff;
      border-radius: 10px 0px 10px 0px;
      text-align: center;
      font-size: 11px;
      display: flex;
      align-items: center;
    }
  }
  .curr-select {
    background-color: #f2fbfe;
    border-color: #1890ff;
    .price-now {
      color: #1890ff;
    }
  }

  &::after {
    flex: none;
    content: "";
    display: block;
    width: 80px;
    height: 1px;
  }
  .contact-item {
    padding-left: 10px;
    font-size: 12px;
    color: #999;
    span:first-child {
      font-weight: bold;
      font-size: 14px;
      color: #262626;
      line-height: 1.5;
      margin-bottom: 4px;
    }
    .cen-discount {
      background: #EEEEEE;
      display: flex;
      align-items: center;
    }
    .cen-discount::before {
      content: "";
      display: block;
      width: 14px;
      height: 14px;
      background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-03-17/12545372eaac4c870b511f0438f1c12d.svg") no-repeat center;
      background-size: cover;
    }
  }
}
.p15 {
  padding: 0 15px;
}
// .img1{
//   height: 494px;
// }
// .img2{
//   height: 274px;
// }
// .img3{
//   height: 219px;
// }
// .img4{
//   height: 219px;
// }
</style>



// WEBPACK FOOTER //
// src/pages/vip/vip.vue